import { useEffect, useState } from "react"

import { Flex, Spin } from "@/atoms"
import { LoadingOutlined } from "@/icons"

import styles from "./TestImpactFormSection.module.scss"

export const LoaderTestImpact = () => {
  const [step, setStep] = useState(1)

  useEffect(() => {
    if (step >= 4) return

    const interval = setTimeout(() => {
      setStep((prevStep) => prevStep + 1)
    }, step * 1500)

    return () => clearTimeout(interval)
  }, [step])

  return (
    <Flex gap={10} align="center" justify="center" className={styles.loader}>
      <Spin
        spinning
        indicator={<LoadingOutlined />}
        rootClassName={styles.loaderText}
      />
      <span className={styles.loaderText}>
        {step === 1 && "Finding relevant issues..."}
        {step === 2 && "Applying guidance..."}
        {step === 3 && "Comparing verdicts..."}
        {step === 4 && "Preparing reasoning..."}
      </span>
    </Flex>
  )
}
